import { render } from "./PlatformSection.vue?vue&type=template&id=78dece62"
import script from "./PlatformSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformSection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/PlatformSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78dece62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78dece62', __exports__)) {
    api.reload('78dece62', __exports__)
  }
  
  module.hot.accept("./PlatformSection.vue?vue&type=template&id=78dece62", () => {
    api.rerender('78dece62', render)
  })

}


export default __exports__